import script from "./Peoples.vue?vue&type=script&setup=true&lang=js"
export * from "./Peoples.vue?vue&type=script&setup=true&lang=js"

import "./Peoples.vue?vue&type=style&index=0&id=fb4544ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb4544ec"]])

export default __exports__